import React, { useState } from 'react'
import './Login.css'

import { Logo } from '../../../utils'
import LoginFunction from '../../../utils/CommonFunctionality/LoginFunction'
import Layout from '../Layout'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
const LoginComponent = (props) => {
    const [open2, setOpen2] = useState(false)
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const isBuyBestProject = global.storeConfigration?.bodyClass2?.value === 'buyBestProject'
    const handleCat = () => {
        setOpen2(false)
    }
    return (
        <>
            <SEOTAG page="Login" />
            <Layout props={props}>
                <div className="clearfix row vcaLogin">
                    <div className="col-lg-3 d-none d-lg-block pad-0">
                        {/*<div className="loginImgBox d-flex justify-content-between flex-column"></div>*/}
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="loginFormBox">
                            {!isVarifiedGfTheme && <Logo className="m-auto" />}
                            <LoginFunction
                                title="Login"
                                subTitle={`Welcome to ${
                                    isVarifiedGfTheme
                                        ? isBuyBestProject
                                            ? 'Buy Best 4 Less'
                                            : 'Retail Rush'
                                        : 'Bargains Depot'
                                }`}
                                after_login_redirect_path="home"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default LoginComponent
